module.exports = __webpack_public_path__ + "img/splatoon.39a55f14.png";